exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".food-nutri-grade-img[data-v-58a7bee2]{position:absolute;bottom:2px;right:2px}.food-nutri-grade-sugre-percent[data-v-58a7bee2]{padding-left:23px;padding-top:3px;font-size:9px;font-weight:700}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-58a7bee2","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ItemNutriGradeTag.vue
// module id = nLuT
// module chunks = 0